import React from "react";
import "../hero/hero-styles.css";
import { FaArrowRightLong } from "react-icons/fa6";

export default function HeroSection() {
  return (
    <section className="hero-section bg-primary-gradient py-14" id="welcome">
      {/* Shape Overlay */}
      <div className="shape shape-blur-3 text-white">
        <svg
          viewBox="0 0 1738 487"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0h1420.92s713.43 457.505 0 485.868C707.502 514.231 0 0 0 0z"
            fill="url(#paint0_linear)"
          />
          <defs>
            <linearGradient
              id="paint0_linear"
              x1="0"
              y1="0"
              x2="1049.98"
              y2="912.68"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="currentColor" stopOpacity=".075" />
              <stop offset="1" stopColor="currentColor" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>{" "}
      </div>
      <div className="shape-overlay">
        <svg
          viewBox="0 0 1738 487"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0h1420.92s713.43 457.505 0 485.868C707.502 514.231 0 0 0 0z"
            fill="url(#paint0_linear)"
          />
          <defs>
            <linearGradient
              id="paint0_linear"
              x1="0"
              y1="0"
              x2="1049.98"
              y2="912.68"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="currentColor" stopOpacity=".05" />
              <stop offset="1" stopColor="currentColor" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>

      {/* Background Elements */}
      <div className="floating-decorations">
        {[...Array(4)].map((_, i) => (
          <div key={i} className={`bubble bubble-${i + 1}`} />
        ))}
      </div>

      {/* Content */}
      <div className="container position-relative text-center">
        <div className="trust-badge">
          <span>🚀</span> Trusted by leading businesses worldwide
        </div>

        <h1 className="hero-heading-text">Business in a Box</h1>

        <p className="hero-subtitle">
          Forward-thinking businesses use <strong>SingleLogin</strong> to{" "}
          <span className="text-secure">Secure</span> and{" "}
          <span className="text-centralize">Centralize</span> all technology
          solutions in one place.
        </p>

        {/* CTA */}
        <div className="cta-wrapper">
          <a href="/#demo" className="btn-gradient flex-row">
            Create a Business Account <FaArrowRightLong/>
          </a>
        </div>
      </div>
    </section>
  );
}
